import { EventStatus } from '@/feature/bets-sbk/hooks/types';
import { isStandaloneScoreboardSport } from '@/utils/sport-utils';

export const HUD_HEIGHTS = {
    prematchHeader: 116,
    // Taller frame for the player-image (tennis) pregame HUD so the rank under the name isn't clipped.
    prematchPlayerHeader: 152,
    liveHeader: 148,
    liveDetailsSlide: 100,
    liveScoreboardHeader: 118,
    sgcInfo: 92,
};

const getMatchUpHeaderHeight = (eventStatus?: EventStatus, sportName?: string, showScoreboard = true) => {
    const isPreGame = eventStatus !== 'LIVE' && eventStatus !== 'FINISHED';
    if (isPreGame) {
        return HUD_HEIGHTS.prematchHeader;
    }
    // Without a scoreboard, EventHudDetails renders bare. Figma has no frame for this case; we
    // mirror the prematch height so live and pregame share the same outer envelope (and matches the
    // pattern Pickem already uses in PickemEventHud).
    if (!showScoreboard) {
        return HUD_HEIGHTS.prematchHeader;
    }
    // Modern-variant sports (tennis) render the scoreboard alone with no HUD-Live carousel slide —
    // see EventHud.tsx `showStandaloneScoreboard`. Classic-variant sports keep the carousel at 148.
    if (sportName && isStandaloneScoreboardSport(sportName)) {
        return HUD_HEIGHTS.liveScoreboardHeader;
    }
    return HUD_HEIGHTS.liveHeader;
};

/**
 * Helper function to get HUD's height dynamically based on the event sport type
 * and whether periods are available or not
 */
export const getHudHeight = ({
    eventStatus,
    showSgcInfo,
    showScoreboard = true,
    sportName,
}: {
    eventStatus: EventStatus;
    showSgcInfo?: boolean;
    showScoreboard?: boolean;
    sportName?: string;
}) => {
    let hudHeight = getMatchUpHeaderHeight(eventStatus, sportName, showScoreboard);
    if (showSgcInfo) {
        hudHeight += HUD_HEIGHTS.sgcInfo;
    }
    return hudHeight;
};
